import {
  CustomTable,
  RankBadge,
  CommonColorButton,
  UserAvatarWithName,
  LoaderBar,
  VideoCardContainer,
} from 'components'
import { GetLeaderboardData } from 'hooks'
import React, { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { CommonUtility } from 'utility'

export const LeaderboardList = ({ winnerSelected,competitionName }) => {
  const navigate = useNavigate()
  const { competitionId, round } = useParams()
  const { data, loading, updateFilter } = GetLeaderboardData(competitionId, round)
  const columns = useMemo(
    () => [
      {
        title: '#Rank',
        dataIndex: 'rank',
        key: 'rank',
        render: value => <RankBadge rank={value} />,
      },
      {
        title: 'Votes',
        dataIndex: 'total_votes',
        key: 'total_votes',
        render: (value, record, index) => (
          <RankBadge type="votes" rank={index + 1} value={value} />
        ),
      },
      {
        title: 'Creator Name',
        dataIndex: 'name',
        key: 'name',
        render: (_, record) => (
          <UserAvatarWithName id={record?.fid} title={record?.name} url={record.image} />
        ),
      },
      {
        title: 'Video',
        dataIndex: 'video',
        key: 'video',
        render: (_, record) => (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={record?.thumbnail_url}
              alt="record?.thumbnail_url"
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '4px',
                objectFit: 'cover',
              }}
            />
            <span style={{ marginLeft: '8px' }}>{record?.title}</span>
          </div>
        ),
      },
      {
        title: 'Views',
        dataIndex: 'total_views',
        key: 'total_views',
        render: value => <span>{CommonUtility.numberFormat(value)}</span>,
      },
      {
        title: 'Comments',
        dataIndex: 'total_comments',
        key: 'total_comments',
        render: value => <span>{CommonUtility.numberFormat(value)}</span>,
      },
    ],
    [data],
  )

  const handleClick = () => {
    navigate(`/app/competitions/select-winners/${competitionId}/${round}`, {
      state: {
        competitionName,
      },
    });
  };
  return (
    <VideoCardContainer className="row">
      <div className="d-flex justify-content-end">
        <CommonColorButton
          disabled={winnerSelected}
          title="Select Winners"
          variant="blue"
          onClick={handleClick}
        />
      </div>
      {loading ? (
        <LoaderBar />
      ) : (
        <CustomTable
          data={data}
          columns={columns}
          rankings
          hideIndex
          updateFilter={updateFilter}
          // pageChanged={pageChanged}
          // page={filter.page}
          loading={loading}
        // total={total}
        />
      )}
    </VideoCardContainer>
  )
}
